import { ButtonColor, ButtonSize, ButtonWithOptions, Spinner } from "@swivl-mono/ui";
import { StackedBarGraph } from "../../Charts/StackedBarGraph/StackedBarGraph";
import { BlankState, MenuOption, TitleForMenuOption } from "../BotAnalyticsDashboard";
import { SequencesDataForType, transformSequencesData } from "../Helpers/DataHelpers";

export const Sequences = ({ sequencesData, sequencesMenu, onMenuChange, onViewAll, channelFilter, title, rawSequencesData, showTypeOption, tableId, showClickSegments }) => {
  // When channelFilter is provided, transform the raw data with the channel filter
  const processedSequencesData = channelFilter && rawSequencesData
    ? transformSequencesData(rawSequencesData, channelFilter, tableId)
    : sequencesData;

  const isLoading = !processedSequencesData;
  const isEmpty = !isLoading && processedSequencesData.total === 0;

  if (isLoading || isEmpty) {
    return (
      <div className="chartBox">
        <div className="chartHeader">
          <div className="chartHeaderTitle">
            <span>{title || "Sequences by"}</span>
          </div>
          <div className="spacer" />
        </div>
        <div className="chartContent">
          <div className="loadingContent">{isLoading ? <Spinner /> : BlankState()}</div>
        </div>
      </div>
    );
  }

  const data = SequencesDataForType(processedSequencesData, sequencesMenu, channelFilter, showClickSegments);

  const shouldShowClickPercentage = showClickSegments &&
    channelFilter === 'SMS' &&
    processedSequencesData.totalClicked !== undefined &&
    processedSequencesData.totalClicked > 0;

  const totalSequences = processedSequencesData.total.toLocaleString();
  const totalDisplay = shouldShowClickPercentage
    ? (() => {
      const percentage = processedSequencesData.totalClicked! / processedSequencesData.total * 100;
      let formattedPercentage: string;
      if (percentage < 5) {
        formattedPercentage = percentage.toFixed(2);
      } else if (percentage < 10) {
        formattedPercentage = percentage.toFixed(1);
      } else {
        formattedPercentage = percentage.toFixed(0);
      }
      return `${totalSequences} (${formattedPercentage}% clicked)`;
    })()
    : totalSequences;

  return (
    <div className="chartBox">
      <div className="chartHeader">
        <div className="chartHeaderTitle">
          <span>{title ? title + " " : "Sequences by "}</span>
          <ButtonWithOptions
            color={ButtonColor.WHITE}
            size={ButtonSize.SMALL}
            buttonOptions={[
              ...(showTypeOption ? [{ title: "Type", name: "Type", onClick: () => onMenuChange("sequencesMenu", "Type") }] : []),
              { title: "Day", name: "Day", onClick: () => onMenuChange("sequencesMenu", "Day") },
              { title: "Time of Day", name: "TimeOfDay", onClick: () => onMenuChange("sequencesMenu", "TimeOfDay") },
              { title: "Day of Week", name: "DayOfWeek", onClick: () => onMenuChange("sequencesMenu", "DayOfWeek") }
            ]}
          >
            {sequencesMenu === 'Type' ? 'Type' : TitleForMenuOption(sequencesMenu)}
          </ButtonWithOptions>
        </div>
        {onViewAll && <a className="viewAll" onClick={onViewAll}>VIEW ALL</a>}
        <div className="spacer" />
        <div className="headerTotal">{totalDisplay}</div>
      </div>
      <div className="chartContent">
        <div className="stackedChart" style={{ marginLeft: '15px' }}>
          <StackedBarGraph
            data={data}
            showingTimeOfDay={sequencesMenu === MenuOption.TimeOfDay}
          />
        </div>
      </div>
    </div>
  );
};
